import $axios from "./request"; //冬才的接口

// 登录
export const $login = (data) => {
  return $axios.post("/login/login", data);
};

// 权限管理
export const $userGetAuth = (params) => {
  return $axios.get("/user/getAuth", { params });
};

// 获取一级权限列表
export const $groupOldGetTopAuthSelect = (params) => {
  return $axios.get("/groupOld/getTopAuthSelect", { params });
};

// 添加权限
export const $groupOldAddAuth = (data) => {
  return $axios.post("/groupOld/addAuth", data);
};

export const $userBind = (data) => {
  //绑定用户
  return $axios.post("/user/bind", data);
};

// 免登录接口
export const $userNoUserLogin = (data) => {
  //免登录接口
  return $axios.post("/user/noUserLogin", data);
};

export const $userSet_lang = (data) => {
  //设计国际化
  return $axios.post("/user/set_lang", data);
};

// 注册
export const $registerRegister = (data) => {
  return $axios.post("/register/register", data);
};

// 修改密码
export const $userModifyPassword = (data) => {
  return $axios.post("/user/modifyPassword", data);
};

// 设置(公共部分)


export const $userGetCountry = (params) => {
  //获取国家
  return $axios.get("/user/getCountry", { params });
};

//获取公司
export const $userGetAllCustomerCompany = (data) => {
  return $axios.post("/user/getAllCustomerCompany", data);
};

export const $userSetCurrent = (data) => {
  //修改币种
  return $axios.post("/user/setCurrent", data);
};

export const $userModifyUserInfo = (data) => {
  //修改设置
  return $axios.post("/user/modifyUserInfo", data);
};
export const $getModifyUserInfo = (params) => {
  //获取设置
  return $axios.get("/user/modifyUserInfo", { params });
};


/*
*询盘模块
*/
export const $Inside_polling = (data) => {
  //内部人员接口
  return $axios.post("/polling/inside_polling", data);
};

export const $customerCustomer_list = (data) => {
  //获取客户列表
  return $axios.post("/customer/customer_list", data);
};

//客户接口
export const $pollingOutside_polling = (data) => {
  return $axios.post("/polling/outside_polling", data);
};

export const $Product = (data) => {
  //查看询盘产品
  return $axios.post("/polling/product", data);
};

export const $offer = (data) => {
  //历史询盘报价
  return $axios.post("/polling/offer", data);
};

export const $add = (data) => {
  //添加询盘
  return $axios.post("/polling/add", data);
};

export const $product_find = (data) => {
  //model
  return $axios.post("/polling/product_find", data);
};

export const $product_brand = (data) => {
  //brand
  return $axios.post("/polling/product_brand", data);
};

// 获取交期
export const $pollingGetLeadingtime = (data) => {
  return $axios.post("/polling/getLeadingtime", data);
};

// 根据产品型号查询品牌
export const $pollingGetBrandByProductId = (data) => {
  return $axios.post("/polling/getBrandByProductId", data);
};

export const $history_quotation = (data) => {
  //历史报价
  return $axios.post("/polling/history_quotation", data);
};

export const $production_item = (data) => {
  //获取报价信息
  return $axios.post("/polling/production_item", data);
};

export const $userUser_list = (data) => {
  //获取销售与采购人员列表
  return $axios.post("/user/user_list", data);
};

export const $pollingDel = (data) => {
  //删除询盘
  return $axios.post("/polling/del", data);
};

export const $pollingFinishInquiry = (data) => {
  //完成询盘
  return $axios.post("/polling/finishInquiry", data);
};

//获取询盘订单接口
export const $orderGetItemOrder = (data) => {
  return $axios.post("/order/getItemOrder", data);
};


//获取联系人
export const $userGetContactsList = (data) => {
  return $axios.post("/user/getContactsList", data);
};

//获取账号
export const $userGetAccountList = (data) => {
  return $axios.post("/user/getAccountList", data);
};

//获取公司下的所有人员
export const $userGetAllCompanyUser = (data) => {
  return $axios.post("/user/getAllCompanyUser", data);
};


/**
 * 开始
 * 2.0 询盘接口 
 */

// 询盘详情添加到询盘
export const $quotationSubmitToQtn = (data) => {
  return $axios.post("/quotation/submitToQtn", data)
}

// 获取供应商
export const $quotationGetSupplierList = (data) => {
  return $axios.post("/quotation/getSupplierList", data)
}

// 修改Owner
export const $pollingModifyOwner = (data) => {
  return $axios.post("/polling/modifyOwner", data)
}

// 获取两种货币的汇率
export const $pollingGetQuotationCurrentRate = (data) => {
  return $axios.post("/polling/getQuotationCurrentRate", data)
}

// 客户提交到报价
export const $quotationCustomerSubmitToQtn = (data) => {
  return $axios.post("/quotation/customerSubmitToQtn", data)
}

// 获取外部用户采购
export const $pollingGetSupplierPurchase = (data) => {
  return $axios.post("/polling/getSupplierPurchase", data)
}

// 删除询盘
export const $pollingDeleteInquiry = (data) => {
  return $axios.post("/polling/deleteInquiry", data)
}

// 获取Original
export const $pollingGetOriginalRFQ = (data) => {
  return $axios.post("/polling/getOriginalRFQ", data)
}

// 获取询盘联系人的名称
export const $userGetRfqContactsList = (data) => {
  return $axios.post("/user/getRfqContactsList", data)
}


// 采购查看团队询盘列表
export const $pollingTeam_product = (data) => {
  return $axios.post("/polling/team_product", data)
}

// 采购获取团队询盘报价列表
export const $orderGet_team_purchase = (data) => {
  return $axios.post("/order/get_team_purchase", data)
}

// 通过询盘id获取询盘详情
export const $pollingGetInquiryInfoById = (data) => {
  return $axios.post("/polling/getInquiryInfoById", data)
}

// 获取sku列表
export const $pollingGetSkuList = (data) => {
  return $axios.post("/polling/getSkuList", data)
}


// 客户新建询盘获取供应商
export const $getAllSupplierList = (data) => {
  return $axios.post("quotation/getAllSupplierList", data)
}

// 通过供应商id获取供应商下的询盘
export const $getInquiryidsBySupplierid = (data) => {
  return $axios.post("quotation/getInquiryidsBySupplierid", data)
}

// 获取询盘详情
export const $getInquiryInfo = (data, signal) => {
  return $axios.post("polling/getInquiryInfo", data, { signal })
}

// 获取货况
export const $getCondition = (data) => {
  return $axios.post("polling/condition", data)
}

// 获取来源列表 
export const $getFromList = (data) => {
  return $axios.post("/polling/getFromList", data)
}

// 询盘已读
export const $pollingIsRead = (data) => {
  return $axios.post("/polling/isRead", data)
}


// 获取采购订单详情数据
export const $getItemPurchaserOrder = (data) => {
  return $axios.post("/order/getItemPurchaserOrder", data)
}

// 获取rfq pdf文档数据
export const $generateRfqPdf = (data) => {
  return $axios.post("/polling/generateRfqPdf", data)
}

// 获取qtn pdf文档数据
export const $generateQtnPdf = (data) => {
  return $axios.post("/polling/generateQtnPdf", data)
}

// 获取询盘下的供应商
export const $getRefVendor = (data) => {
  return $axios.post("/polling/getVendorListByInquiryId", data)
}

//一键有货
export const $getNewItemPurchasePriceByProductIds = (data) => {
  return $axios.post("/quotation/getNewItemPurchasePriceByProductIds", data)
}

//获取询盘未读消息
export const $getUserMsg = (data) => {
  return $axios.post("/polling/getUserMsg", data)
}

//获取询盘items
export const $getRfqItems = (data) => {
  return $axios.post("/rfq/getRfqItems", data)
}


//获取报价items
export const $getQtnItems = (data) => {
  return $axios.post("/rfq/getQtnItems", data)
}


//批量无货
export const $batchOutStock = (data) => {
  return $axios.post("/quotation/batchOutStock", data)
}

//设置未读/已读
export const $setInquiryRead = (data) => {
  return $axios.post("/polling/setInquiryRead", data)
}


//设置置顶
export const $setTopup = (data) => {
  return $axios.post("/polling/setTopup", data)
}

//标记已完成
export const $setCompleteTag = (data) => {
  return $axios.post("/polling/setCompleteTag", data)
}


//获取询盘用户分类列表
export const $getCategoryList = (data) => {
  return $axios.post("/polling/getCategoryList", data)
}


//编辑分类
export const $editCategory = (data) => {
  return $axios.post("/polling/editCategory", data)
}


//删除分类
export const $delCategory = (data) => {
  return $axios.post("/polling/delCategory", data)
}

//新建分类
export const $addCategory = (data) => {
  return $axios.post("/polling/addCategory", data)
}


//添加分类到询盘
export const $addCategoryToInquiry = (data) => {
  return $axios.post("/polling/addCategoryToInquiry", data)
}


//设置标记
export const $setTag = (data) => {
  return $axios.post("/polling/setTag", data)
}


//清除标记
export const $clearTag = (data) => {
  return $axios.post("/polling/clearTag", data)
}


//置顶排序
export const $topUpSort = (data) => {
  return $axios.post("/polling/topUpSort", data)
}

//判断分类颜色有没有用到
export const $hasCategory = (data) => {
  return $axios.post("/polling/hasCategory", data)
}

//询盘全部已读
export const $allRead = (data) => {
  return $axios.post("/polling/allRead", data)
}


//获取品牌关联的采购列表
export const $getBrandPurchasesList = (data) => {
  return $axios.post("/Polling/getBrandPurchasesList", data)
}


//判断分类名称有没有用到
export const $hasCategoryName = (data) => {
  return $axios.post("/polling/hasCategoryName", data)
}


//绑定品牌和采购
export const $bindPurchaserAndBrand = (data) => {
  return $axios.post("/Polling/bindPurchaserAndBrand", data)
}


//通过品牌id获取关联的采购
export const $getPurchasesByBrandId = (data) => {
  return $axios.post("/polling/getPurchasesByBrandId", data)
}


//获取自定义采购
export const $getCustomPurchaseList = (data) => {
  return $axios.post("/user/getCustomPurchaseList", data)
}


//自动报价-添加到报价
export const $autoQuotationAddQTN = (data) => {
  return $axios.post("/quotation/autoQuotation", data)
}

//根据联系人获取询盘列表（个人+公开）
export const $getCustomerRfq = (data) => {
  return $axios.post('/polling/getCustomerRfq', data)
}


//切换自动报价）
export const $switchAutoQuotation = (data) => {
  return $axios.post('/quotation/switchAutoQuotation', data)
}


//获取品牌报价列表
export const $getBrandPurchase = (data) => {
  return $axios.post('/order/getBrandPurchase', data)
}


//采购保存报价(我的报价)
export const $setQuotationByPurhaser = (data) => {
  return $axios.post('/quotation/setQuotationByPurhaser', data)
}


//获取公开询盘懒加载子级
export const $getRfqList = (data) => {
  return $axios.post('/polling/rfqList', data)
}


//获取Pdf列表数据
export const $getPdfDataList = (data) => {
  return $axios.post('/polling/getPdfDataList', data)
}


//获取询盘的pdf设置
export const $getInquiryPdfSet = (data) => {
  return $axios.post('/polling/getInquiryPdfSet', data)
}


//设置询盘的pdf
export const $setInquiryPdf = (data) => {
  return $axios.post('/polling/setInquiryPdf', data)
}


//迭代获取rfq pdf文档数据
export const $newGenerateRfqPdf = (data) => {
  return $axios.post('/polling/newGenerateRfqPdf', data)
}

//迭代获取qtn pdf文档数据
export const $newGenerateQtnPdf = (data) => {
  return $axios.post('/polling/newGenerateQtnPdf', data)
}


//获取单条询盘
export const $getQtnList = (data) => {
  return $axios.post('/polling/qtnList', data)
}



/** 结束 */


/** 
 * 添加到报价
*/

export const $pollingInquiry_history = (data) => {
  //历史询盘
  return $axios.post("/polling/inquiry_history", data);
};

export const $pollingQuotation = (data) => {
  //保存报价
  return $axios.post("/polling/quotation", data);
};

export const $orderOrder_list = (data) => {
  //获取订单列表
  return $axios.post("/order/order_list", data);
};

export const $orderOrder_info = (data) => {
  //获取订单详情信息
  return $axios.post("/order/order_info", data);
};

export const $orderOrder_product = (data) => {
  //获取订单产品信息
  return $axios.post("/order/order_product", data);
};

export const $pollingHistory_quotation = (data) => {
  //历史报价
  return $axios.post("/polling/history_quotation", data);
};

export const $orderSave_quotation = (data) => {
  //保存报价订单
  return $axios.post("/order/save_quotation", data);
};

export const $quotationSave_quotation = (data) => {
  //保存报价转询盘
  return $axios.post("/quotation/save_quotation", data);
};

export const $quotationNew_quotation = (data) => {
  //新增订单转询盘
  return $axios.post("/quotation/new_quotation", data);
};

// 添加到订单
export const $orderGet_inquiry_by_key = (data) => {
  //获取询盘列表
  return $axios.post("/order/get_inquiry_by_key", data);
};

export const $orderGet_inquiry_info = (data) => {
  //获取询盘信息
  return $axios.post("/order/get_inquiry_info", data);
};

export const $orderOrder_listo = (data) => {
  //获取订单列表
  return $axios.post("/order/order_list", data);
};

export const $orderSave_order = (data) => {
  //保存报价订单
  return $axios.post("/order/save_order", data);
};

export const $orderDel_order = (data) => {
  //删除订单信息
  return $axios.post("/order/del_order", data);
};

export const $orderNew_order = (data) => {
  //新增报价订单
  return $axios.post("/order/new_order", data);
};

//获取所有的用户及下级信息
export const $userGesUserSales = (data) => {
  return $axios.post("user/gesUserSales", data)

}

//客户公开询盘详情添加到询盘
export const $submitDiscoverToQtn = (data) => {
  return $axios.post("quotation/submitDiscoverToQtn", data)
}

//获取采购订单列表
export const $getPurchaseOrderList = (data) => {
  return $axios.post("order/getPurchaseOrderList", data)
}

//保存采购订单
export const $savePurchaseorder = (data) => {
  return $axios.post("order/savePurchaseorder", data)
}

//内部人员询盘表格
export const $getInsidePollingTableList = (data,signal) => {
  return $axios.post("/polling/getInsidePollingTableList", data,{ signal })
}

//采购报价列表
export const $purchaseQtnList = (data,signal) => {
  return $axios.post("/polling/rfqList", data,{signal})
}


//我的报价列表
export const $myQtnList = (data) => {
  return $axios.post("/polling/qtnList", data)
}


//我的报价总数
export const $pollingQtnCount = (data) => {
  return $axios.post("/polling/qtnCount", data)
}


//设置询盘相关字段
export const $setInquiryCustomField = (data) => {
  return $axios.post("/polling/setInquiryCustomField", data)
}


//获取询盘相关字段
export const $getInquiryCustomField = (data) => {
  return $axios.post("/polling/getInquiryCustomField", data)
}


//获取授权人操作权限
export const $getAuthorizedAuth = (data) => {
  return $axios.post("/polling/getAuthorizedAuth", data)
}

//手动生成邮件草稿询盘
export const $handAddEmailRfq = (data) => {
  return $axios.post("/polling/handAddEmailRfq", data)
}


//手动生成邮件提交报价询盘
export const $handAndsubmitEmailRfq = (data) => {
  return $axios.post("/quotation/handAndsubmitEmailRfq", data)
}


//获取品牌自定义所有品牌id
export const $getCustomBrandIdArr = (data) => {
  return $axios.post("/polling/getCustomBrandIdArr", data)
}


//获取客户分析模块品牌关联的所有采购
export const $getCustomerSearchOwnerArr = (data) => {
  return $axios.post("/polling/getCustomerSearchOwnerArr", data)
}



/**
 * 开始
 * 2.0 报价接口
 */

// 获取下拉框对应的草稿报价数据
export const $orderGetItemInfoByInquiryId = (data) => {
  return $axios.post('/order/getItemInfoByInquiryId', data)
}


/**
 * 结束
 */

// 报价

export const $orderget_order_purchase = (data) => {
  //获取报价订单
  return $axios.post("/order/get_order_purchase", data);
};

export const $orderSet_quotation = (data) => {
  //保存询盘报价
  return $axios.post("/order/set_quotation", data);
};

export const $orderNew_quotation_fun = (data) => {
  //新建询盘报价
  return $axios.post("/order/new_quotation_fun", data);
};

export const $orderDel_quotation = (data) => {
  //删除报价
  return $axios.post("/order/del_quotation", data);
};

export const $orderGet_inquiry_list_by_product = (data) => {
  //获取询盘列表通过产品
  return $axios.post("/order/get_inquiry_list_by_product", data);
};

export const $orderPull_excel = (data) => {
  //下载报价
  return $axios.post("/order/pull_excel", data);
};

export const $orderHistory_order = (data) => {
  //产品历史订单
  return $axios.post("/order/history_order", data);
};

export const $quotationServiceQuotation = (data) => {
  //新增报价通过询盘
  return $axios.post("/quotation/serviceQuotation", data);
};

export const $country_customer_list = (data) => {
  //获取国家列表树中的客户
  return $axios.post("/customer/country_customer_list", data);
};


//海外供应商保存
export const $saveQtnFromContact = (data) => {
  return $axios.post("/opportunity/saveQtnFromContact", data);
};


//海外供应商链接提交联系人询价
export const $submitQtnFromContact = (data) => {
  return $axios.post("/opportunity/submitQtnFromContact", data);
};



/**
 * 批量报价
 */

// 获取批量报价列表
export const $getWaterfallList = (data) => {
  return $axios.post("/waterfall/list", data);
};


// 批量报价列表保存批量报价
export const $saveBulkQtnFromList = (data) => {
  return $axios.post("/waterfall/saveBulkQtnFromList", data);
};


// 批量报价列表应用批量报价
export const $applyBulkQtnFromList = (data) => {
  return $axios.post("/waterfall/applyBulkQtnFromList", data);
};


// 获取当前登录用户所有的供应商联系人
export const $getAllVendorContacts = (data) => {
  return $axios.post("/waterfall/getAllVendorContacts", data);
};


// 批量报价列表删除批量报价
export const $deleteBulkQtnFromList = (data) => {
  return $axios.post("/waterfall/deleteBulkQtnFromList", data);
};


// 添加供应商联系人列表型号
export const $addVendorContactProduct = (data) => {
  return $axios.post("/waterfall/addInquiryVendorContactProduct", data);
};


// 获取当供应商联系人的交易状态
export const $getVendorDealStatus = (data) => {
  return $axios.post("/waterfall/getVendorDealStatus", data);
};


// 获取当前登录用户所有的供应商联系人owner
export const $getVendorContactsOwner = (data) => {
  return $axios.post("/waterfall/getVendorContactsOwner", data);
};


// 获取当前登录用户所有的供应商类型
export const $getVendorType = (data) => {
  return $axios.post("/waterfall/getVendorType", data);
};


// 获取批量报价详情批量报价列表
export const $getBulkQtnList = (data) => {
  return $axios.post("/waterfall/getBulkQtnList", data);
};


// 获取当前登录用户所有的供应商联系人列表
export const $getAllVendorContactsList = (data) => {
  return $axios.post("/waterfall/getAllVendorContactsList", data);
};



/**
 * 探索下的公开询盘
 * 
 */

//discover获取公开询盘列表
export const $getDiscoverInquiryList = (data) => {
  return $axios.post('/polling/getDiscoverInquiryList', data)
}

//收藏取消discover询盘
export const $favoriteInquiry = (data) => {
  return $axios.post('/polling/favoriteInquiry', data)
}


/**
 * 结束
 */


/**
 * 设置 > 权限管理
 */

//获取路由
export const $routeIndex = (params) => {
  return $axios.get("/route/index", { params });
};

// 获取左侧角色权限列表
export const $groupOldGetUserGroupList = (data) => {
  return $axios.post('/groupOld/getUserGroupList', data)
}

// 获取用户列表
export const $groupOldGetMissuUsersList = (data) => {
  return $axios.post('/groupOld/getMissuUsersList', data)
}

// 选择权限列表
export const $groupOldGetAuthList = (data) => {
  return $axios.post('/groupOld/getAuthList', data)
}

// 获取所属公司
export const $groupOldGetCustomerCompany = (data) => {
  return $axios.post('/groupOld/getCustomerCompany', data)
}

// 获取部门列表
export const $groupOldGetUserDepartment = (data) => {
  return $axios.post('/groupOld/getUserDepartment', data)
}

// 获取所有用户列表
export const $groupOldGetMissuUsers = (data) => {
  return $axios.post('/groupOld/getMissuUsers', data)
}

// 新增角色
export const $groupOldAddUserGroup = (data) => {
  return $axios.post('/groupOld/addUserGroup', data)
}

// 获取编辑角色数据
export const $groupOldGetEditUserGroup = (data) => {
  return $axios.post('/groupOld/getEditUserGroup', data)
}

// 编辑保存
export const $groupOldEditUserGroup = (data) => {
  return $axios.post('/groupOld/editUserGroup', data)
}

// 删除角色
export const $groupOldDeleteUserGroup = (data) => {
  return $axios.post('/groupOld/deleteUserGroup', data)
}

// 角色添加用户
export const $groupOldAddToUserGroup = (data) => {
  return $axios.post('/groupOld/addToUserGroup', data)
}

// 角色移除用户
export const $groupOldMoveToUserGroup = (data) => {
  return $axios.post('/groupOld/moveToUserGroup', data)
}

// 获取角色
export const $userGetUserAuth = (data) => {
  return $axios.post('/user/getUserAuth', data)
}

// 获取报价详情
export const $getMyQtnInfo = (data,signal) => {
  return $axios.post('/polling/getMyQtnInfo', data,{signal})
}

// 新建询盘提交到报价
export const $newAndsubmitToQtn = (data) => {
  return $axios.post('/quotation/newAndsubmitToQtn', data)
}

// 新建编辑保存，内部询盘
export const $updatePolling = (data) => {
  return $axios.post('/polling/updatePolling', data)
}

// 新建编辑保存，外部询盘
export const $updateCustomersPolling = (data) => {
  return $axios.post('/polling/updateCustomersPolling', data)
}

// 新建编辑保存，外部(定向)询盘
export const $newCustomerSubmitToQtn = (data) => {
  return $axios.post('/quotation/newCustomerSubmitToQtn', data)
}


// 获取pdf公司名称列表
export const $getPdfCompanyNameList = (data) => {
  return $axios.post('/polling/getPdfCompanyNameList', data)
}


// 获取pdf公司地址列表
export const $getPdfStreetAddressList = (data) => {
  return $axios.post('/polling/getPdfStreetAddressList', data)
}


// 获取pdf销售邮箱列表
export const $getPdfSaleEmailList = (data) => {
  return $axios.post('/polling/getPdfSaleEmailList', data)
}


// 获取pdf公司邮箱列表
export const $getPdfCompanyEmailList = (data) => {
  return $axios.post('/polling/getPdfCompanyEmailList', data)
}


// 获取pdf公司网址列表
export const $getPdfWebsiteList = (data) => {
  return $axios.post('/polling/getPdfWebsiteList', data)
}


// 添加Pdf列表数据
export const $addPdfData = (data) => {
  return $axios.post('/polling/addPdfData', data)
}





/**
 * 探索下的公开询盘
 * 
 */

// 获取discover询盘详情
export const $getDsInquiryItemList = (data) => {
  return $axios.post('/polling/getDsInquiryItemList', data)
}

// 获取discover询盘详情报价列表
export const $getPurchaseList = (data) => {
  return $axios.post('/polling/getDsInquiryItemPurchasePriceList', data)
}

// 添加到询盘来自discover
export const $addToRFQ = (data) => {
  return $axios.post('/quotation/addInquiryFromDiscover', data)
}



/**
 * 客户模块
 * 
*/

// 获取account下的rfq
export const $getAccountRfq = (data) => {
  return $axios.post('/polling/getAccountRfq', data)
}

// 获取account的qtn
export const $getAccountQtn = (data) => {
  return $axios.post('/polling/getAccountQtn', data)
}

// 通过客户id获取account的草稿状态的rfq
export const $getAccountDratRfq = (data) => {
  return $axios.post('/polling/getAccountDratRfq', data)
}